module.exports={
  "name": "localmed-api",
  "version": "0.22.0",
  "description": "API Client for client & server JavaScript applications.",
  "main": "./lib",
  "scripts": {
    "format": "prettier --write 'src/**/*.js'",
    "lint": "eslint src",
    "prepublish": "babel src --out-dir lib --ignore '*/__tests__/*'",
    "test": "TZ=UTC jest"
  },
  "author": "LocalMed <developers@localmed.com>",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "git@gitlab.com:localmed/localmed-api-js.git"
  },
  "homepage": "https://gitlab.com/localmed/localmed-api-js",
  "dependencies": {
    "axios": "^0.16.2",
    "parse-links": "~0.1.0",
    "url-parse": "^1.1.7"
  },
  "devDependencies": {
    "babel": "^6.5.2",
    "babel-cli": "6.10.1",
    "babel-eslint": "^7.2.3",
    "babel-preset-es2015": "^6.13.2",
    "babel-preset-stage-2": "6.13.0",
    "babelify": "^6.0.2",
    "core-js": "^1.2.3",
    "es6-promise": "^2.0.1",
    "eslint": "^3.19.0",
    "eslint-config-airbnb": "^15.0.1",
    "eslint-config-prettier": "^2.3.0",
    "eslint-plugin-import": "^2.2.0",
    "eslint-plugin-jsx-a11y": "^5.0.1",
    "eslint-plugin-react": "^7.0.1",
    "jest": "^20.0.4",
    "prettier": "^1.5.2",
    "sinon": "^1.11.1"
  }
}
